import {Component, Input, OnInit, AfterViewInit} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import { BuildingsService } from '../../service/buildings.service';

declare var $:any;

@Component({
  selector: 'app-upgrade',
  templateUrl: './thankyou.component.html',
  styleUrls: ['./thankyou.component.css']
})
export class UpgradeSuccess implements OnInit, AfterViewInit {

  state = false;
  userBuildingId = localStorage.getItem('userBuildingId');

  constructor(private router: Router,
              private route: ActivatedRoute,
              private buildingService: BuildingsService,) { }

  ngOnInit() {
    sessionStorage.removeItem('buildingImage');
    sessionStorage.removeItem('userImage');
    sessionStorage.removeItem('groupImage');
    sessionStorage.removeItem('existingBuildingImage');
    sessionStorage.clear();

    history.pushState(null, null, location.href);
    window.onpopstate = function () {
      history.go(1);
    };

    var buildingIds = this.userBuildingId.split(',');
    this.buildingService.getAllBuildingsByUser(buildingIds).subscribe(
      (buildings) => {
        if(buildings.success){

          const selectedBuilding = buildings.data[0];
          localStorage.setItem("currentBuildingMaintenanceActive", selectedBuilding.isMaintenanceActive.toString());

        }
      })

  }

  ngAfterViewInit(){

    this.route.queryParams.subscribe((data)=>{
     // console.log('=========================', data)
     if(data.type === 'true'){
      this.state = true;
     }else{
      this.state = false;
     }
    })
  }
}
